(() => {
  const header = document.querySelector("[data-hq-header]");

  if (!header || header.dataset.hqReady === "true") return;
  header.dataset.hqReady = "true";

  const desktopQuery = window.matchMedia("(min-width: 1181px)");
  const menuItems = Array.from(header.querySelectorAll("[data-hq-menu-item]"));
  const mobileOpenButtons = header.querySelectorAll("[data-hq-mobile-open]");
  const mobileCloseButtons = header.querySelectorAll("[data-hq-mobile-close]");
  const mobileDrawer = header.querySelector(".hq-mobile-drawer");
  const searchDialog = header.querySelector("[data-hq-search-dialog]");
  const searchInput = header.querySelector("[data-hq-search-input]");
  const categoryTabs = Array.from(
    header.querySelectorAll("[data-hq-category-target]"),
  );
  const categoryPanels = Array.from(
    header.querySelectorAll("[data-hq-category-panel]"),
  );
  let closeTimer;

  function setMenu(activeItem, open) {
    menuItems.forEach((item) => {
      const isActive = item === activeItem && open;
      item.classList.toggle("is-open", isActive);
      item.querySelector("[data-hq-menu-toggle]")
        ?.setAttribute("aria-expanded", String(isActive));
    });
  }

  function closeMenus() {
    menuItems.forEach((item) => setMenu(item, false));
  }

  function openMenu(item) {
    window.clearTimeout(closeTimer);
    setMenu(item, true);
  }

  function scheduleMenuClose(item) {
    window.clearTimeout(closeTimer);
    closeTimer = window.setTimeout(() => {
      if (!item.matches(":hover") && !item.contains(document.activeElement)) {
        setMenu(item, false);
      }
    }, 140);
  }

  function setMobileMenu(open) {
    document.body.classList.toggle("hq-mobile-open", open);
    mobileDrawer?.setAttribute("aria-hidden", String(!open));
    mobileOpenButtons.forEach((button) => {
      button.setAttribute("aria-expanded", String(open));
    });
  }

  function setCategory(category) {
    categoryTabs.forEach((tab) => {
      const isActive = tab.dataset.hqCategoryTarget === category;
      tab.classList.toggle("is-active", isActive);
      tab.setAttribute("aria-selected", String(isActive));
    });

    categoryPanels.forEach((panel) => {
      const isActive = panel.dataset.hqCategoryPanel === category;
      panel.classList.toggle("is-active", isActive);
      panel.hidden = !isActive;
    });
  }

  function updateCartCount() {
    if (!window.fetch) return;

    window.fetch("/cart.js", {
      headers: { Accept: "application/json" },
      credentials: "same-origin",
    })
      .then((response) => (response.ok ? response.json() : null))
      .then((cart) => {
        if (!cart || typeof cart.item_count !== "number") return;
        header.querySelectorAll("[data-hq-cart-count]").forEach((count) => {
          count.textContent = String(cart.item_count);
        });
      })
      .catch(() => {});
  }

  menuItems.forEach((item) => {
    const toggle = item.querySelector("[data-hq-menu-toggle]");

    toggle?.addEventListener("click", (event) => {
      event.stopPropagation();
      const willOpen = !item.classList.contains("is-open");
      closeMenus();
      setMenu(item, willOpen);
    });

    item.addEventListener("pointerenter", (event) => {
      if (desktopQuery.matches && event.pointerType !== "touch") openMenu(item);
    });

    item.addEventListener("pointerleave", (event) => {
      if (desktopQuery.matches && event.pointerType !== "touch") {
        scheduleMenuClose(item);
      }
    });

    item.addEventListener("focusin", () => {
      if (desktopQuery.matches) openMenu(item);
    });

    item.addEventListener("focusout", () => {
      if (desktopQuery.matches) scheduleMenuClose(item);
    });
  });

  categoryTabs.forEach((tab, index) => {
    const activate = () => setCategory(tab.dataset.hqCategoryTarget);

    tab.addEventListener("click", activate);
    tab.addEventListener("focus", activate);
    tab.addEventListener("pointerenter", (event) => {
      if (desktopQuery.matches && event.pointerType !== "touch") activate();
    });
    tab.addEventListener("keydown", (event) => {
      const isNext = event.key === "ArrowDown" || event.key === "ArrowRight";
      const isPrevious = event.key === "ArrowUp" || event.key === "ArrowLeft";
      let nextIndex = index;

      if (isNext) nextIndex = (index + 1) % categoryTabs.length;
      else if (isPrevious) {
        nextIndex = (index - 1 + categoryTabs.length) % categoryTabs.length;
      } else if (event.key === "Home") nextIndex = 0;
      else if (event.key === "End") nextIndex = categoryTabs.length - 1;
      else return;

      event.preventDefault();
      categoryTabs[nextIndex].focus();
      setCategory(categoryTabs[nextIndex].dataset.hqCategoryTarget);
    });
  });

  mobileOpenButtons.forEach((button) => {
    button.addEventListener("click", () => setMobileMenu(true));
  });

  mobileCloseButtons.forEach((button) => {
    button.addEventListener("click", () => setMobileMenu(false));
  });

  header.querySelectorAll("[data-hq-search-open]").forEach((button) => {
    button.addEventListener("click", () => {
      closeMenus();
      setMobileMenu(false);
      if (typeof searchDialog?.showModal === "function") {
        searchDialog.showModal();
        window.setTimeout(() => searchInput?.focus(), 30);
      } else {
        window.location.href = "/search";
      }
    });
  });

  header.querySelectorAll("[data-hq-search-close]").forEach((button) => {
    button.addEventListener("click", () => searchDialog?.close());
  });

  searchDialog?.addEventListener("click", (event) => {
    if (event.target !== searchDialog) return;
    const bounds = searchDialog.getBoundingClientRect();
    const outside =
      event.clientX < bounds.left ||
      event.clientX > bounds.right ||
      event.clientY < bounds.top ||
      event.clientY > bounds.bottom;
    if (outside) searchDialog.close();
  });

  document.addEventListener("click", (event) => {
    if (!event.target.closest("[data-hq-menu-item]")) closeMenus();
  });

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;
    closeMenus();
    setMobileMenu(false);
  });

  desktopQuery.addEventListener("change", (event) => {
    if (!event.matches) {
      closeMenus();
      setMobileMenu(false);
    }
  });

  window.addEventListener("pageshow", updateCartCount);
  document.addEventListener("cart:updated", updateCartCount);
  updateCartCount();
})();
